import React from 'react';

import { Form } from 'antd';
import { Input, InputGroup, Icon } from 'rsuite';
import moment from 'moment';

import Cache from '../../frame/Cache';
import Config from '../../config/Config'
import WidgetAjax from '../../widget/WidgetAjax';
import WidgetTable from '../../widget/WidgetTable';
import WidgetDrawer from '../../widget/WidgetDrawer';
import WidgetTreePicker from '../../widget/WidgetTreePicker';
import WidgetMessage from '../../widget/WidgetMessage';
import WidgetSelect from '../../widget/WidgetSelect';
import WidgetDatePicker from '../../widget/WidgetDatePicker';

import 'antd/dist/antd.css';

let arr = [];


class UserCreate extends React.Component
{
    constructor( props )
    {
        super(props);

        let basePath = Config.getBasePath();

        

        let isCreate = true, user={}, title = "创建用户";

        if( this.props.location!==undefined && this.props.location.state!==undefined )
        {
            isCreate = this.props.location.state.isCreate!==undefined ? this.props.location.state.isCreate : true;

            user = this.props.location.state.user!==undefined ? this.props.location.state.user : {};
        }

        if( basePath.endsWith('/')===false )
        {
            basePath = basePath + '/';
        }

        if( isCreate===false )
        {
            title = "修改用户"
        }

        this.drawerConfirm = this.drawerConfirm.bind(this);
        this.groupConfirm = this.groupConfirm.bind(this);


        let userInfo = sessionStorage.getItem("_user_info_");

        if( userInfo!==undefined && userInfo!==null )
        {
            userInfo = JSON.parse(userInfo);
        }

        this.state = {
            userInfo:userInfo,
            basePath:basePath,
            isCreate: isCreate,
            title:title,
            user : user,
            roleOptions : {
                title:"请选择角色（必选项）",
                // type : 'check'
            },
            groupData : undefined,
            layout : {
                labelCol: { span: 6 },
                wrapperCol: { span: 16 },
            },
            drawerOptions:{
                size:'md',
                button : true,
                "confirmFunction" : this.drawerConfirm,
                backdrop:'static'
            },
            groupOptions:{
                size:'md',
                button : true,
                "confirmFunction" : this.groupConfirm,
                backdrop:'static'
            },
            columns:[
                { name: 'id', title: '用户部门id', type: 'string', description: '用户部门id', properties: { hidden: true }},
                { name: 'parent_id', title: '上级部门id', type: 'string', description: '上级部门id', properties: { hidden: true }},
                { name: 'name', title: '用户部门名称', type: 'string', description: '用户部门名称', properties: { hidden: false, click:"departmentOnSelect"}},
                { name: 'parent_name', title: '上级部门名称', type: 'string', description: '上级部门名称', properties: { hidden: false }}, 
            ],
            columns1:[
                { name: 'id', title: '分组id', type: 'string', description: '用户部门id', properties: { hidden: true }},
                { name: 'name', title: '分组名称', type: 'string', description: '用户部门名称', properties: { hidden: false, click:"departmentOnSelect"}}
            ],
            tableOptions : {
                records : 10
            },
            departments:[],
            groups:undefined,
            userGroups:[],
            departments:[],
            confirmDepartments:[],
            userDepartments:[],
            username:user.username, 
            realname:user.realname,
            cell:user.cell,
            email:user.email,
            remark:user.remark,
            departmentNames:undefined,
            userDepartmentNames:undefined,
            confirmDepartmentNames:undefined,
            messageOptions:{
                title:"新增用户"
            },
            dateOptions : {
                name : "",
                isLeftTitle : false,
                dateType : "date",
                dateTypes : [{title:'日', value:'date'}],
                datePickerType:'point', 
            },
            endDateOptions : {
                name : "",
                isLeftTitle : false,
                dateType : "date",
                dateTypes : [{title:'日', value:'date'}],
                datePickerType:'point', 
            },
            startDate:undefined,
            startDate1 : user.startDate1,
            filterTypeOptions : {
                title : "请选择归属领域（必选项）"
            },
            filterBankData:[],
            circleCenterValue:user.realmId,
            realmId:undefined,
            groupings:undefined,
            groupSearch:[],
            groupingNames:"",
            flag:false,
            options : {
                records : 10
            },
        }

        this.backUser = this.backUser.bind(this);
        this.inputOnchange = this.inputOnchange.bind(this);

        this.loadGroup = this.loadGroup.bind(this);
        this.onLoadGroup = this.onLoadGroup.bind(this);

        this.departmentSelect = this.departmentSelect.bind(this);
        this.groupingSelect = this.groupingSelect.bind(this)

        this.keyWordKeyUp = this.keyWordKeyUp.bind(this);
        this.keyWordOnChange = this.keyWordOnChange.bind(this);

        this.departmentSearch = this.departmentSearch.bind(this);
        this.onDepartmentSearch = this.onDepartmentSearch.bind(this);

        this.pageTurning = this.pageTurning.bind(this);
        this.groupOnSelect = this.groupOnSelect.bind(this);

        this.onEvent = this.onEvent.bind(this);
        this.removeDepartment = this.removeDepartment.bind(this); 

        this.cancel = this.cancel.bind(this);
        this.submitUser = this.submitUser.bind(this);
        this.onsubmitUser = this.onsubmitUser.bind(this);
        this.onEdituser = this.onEdituser.bind(this);

        this.setUserGroup = this.setUserGroup.bind(this);
        this.onSetUserGroup = this.onSetUserGroup.bind(this);

        this.setUserDepartment = this.setUserDepartment.bind(this);
        this.setUserRole = this.setUserRole.bind(this)
        this.onSetUserRole = this.onSetUserRole.bind(this)
        this.onSetUserDepartment = this.onSetUserDepartment.bind(this);
        this.onLoadUserGroup = this.onLoadUserGroup.bind(this);
        this.onLoadUserDepartment = this.onLoadUserDepartment.bind(this);

        this.onDateSelect = this.onDateSelect.bind(this);
        this.onEndDateSelect = this.onEndDateSelect.bind(this);
        this.onSelectCircleCenter = this.onSelectCircleCenter.bind(this);

        this.belongs = this.belongs.bind(this);
        this.onBelongs = this.onBelongs.bind(this);
        this.loadUserGrouping = this.loadUserGrouping.bind(this);
        this.onLoadUserGrouping = this.onLoadUserGrouping.bind(this);

        this.groupKeyWordOnChange = this.groupKeyWordOnChange.bind(this);
        this.groupKeyWordKeyUp = this.groupKeyWordKeyUp.bind(this);

        this.onGroupEvent = this.onGroupEvent.bind(this);
        this.removeDate = this.removeDate.bind(this);
        
        this.startValueDate = this.startValueDate.bind(this);
        this.onstartValueDate = this.onstartValueDate.bind(this);

        this.loadUserGroupName = this.loadUserGroupName.bind(this);
        this.onUserGroupName = this.onUserGroupName.bind(this);

        this.groupPageTurning = this.groupPageTurning.bind(this);
    }

    componentDidMount()
    {
        let { user,filterBankData } = this.state;
        this.belongs()
        this.loadGroup();
        this.departmentSearch(1);
        this.loadUserGrouping()

        if( user!==undefined && user.UID  )
        {
            this.loadUserGroup();
            this.loadUserDepartment();
            this.loadUserGroupName()

            let params = {
                UID:user.UID
            }
            this.setState({username:user.username, realname:user.realname} );
        }
    }

    drawerRef = (ref) => {
        this.drawerRef = ref;
    }

    groupSearchRef = (ref) => {
        this.groupSearchRef = ref;
    }
    
    // 信息弹框
    messageRef = ( ref ) => 
    {
        this.messageRef = ref;
    }


    /**
     * 返回用户管理界面
     */
    backUser()
    {
        this.props.history.push({pathname:"/home/user"})
    }

    /**
     * 取消
     */
    cancel()
    {
        const { user, userGroups, userDepartments, userDepartmentNames, circleCenterValue, groupingNames,userGroupSearchData} = this.state;

        if( user && user.UID!==undefined )
        {
            this.setState({username:user.username, realname:user.realname,
                cell:user.cell, email:user.email,remark:user.remark,
                confirmDepartments:userDepartments, confirmDepartmentNames:userDepartmentNames,
                departments:userDepartments,groups:userGroups, departmentNames:userDepartmentNames,circleCenterValue :user.circleCenterValue,
                groupingNames:groupingNames,groupSearchData:userGroupSearchData
            } );
        }
        else
        {
            this.setState({username:undefined, realname:undefined,
                cell:undefined, email:undefined,remark:undefined,
                departments:[], groups:[], departmentNames:"", 
                confirmDepartments:[], confirmDepartmentNames:"",
                startDate1:undefined,
                startDate:undefined,
                endDate : undefined,
                circleCenterValue : undefined,
                groupingNames:undefined,
                groupSearchData:undefined
            });
        }
        this.backUser()
        
    }

    // 用户归属
    belongs()
    {
        const { basePath,userInfo } = this.state;
        let params={
            page:1,
            records:9999
        };

        if(userInfo.realmId !== undefined && userInfo.realmId !== null && userInfo.realmId !== "")
        {
            params["realm_id"] = userInfo.realmId;
        }


        WidgetAjax.ajax({url:basePath + 'realm/search', params:params, callback:this.onBelongs});
    }

    onBelongs(result)
    {
        let { filterTypeOptions,user } = this.state

        if( result.status===0 )
        {
            let filterBankData = [];

            for(let item of result.results)
            {
                item["value"] = item.id;
                item["label"] = item.name;
                if(user.realmId === item.value){
                    filterTypeOptions.title = item.label;
                    this.setState({flag:true})
                }
                filterBankData.push(item);
            }

            this.setState({filterBankData:filterBankData});
        }
        else if( result.status===10 )
        {
            Cache.logout(this.props);
        }
    }

    loadGroup()
    {
        const { basePath, circleCenterValue,user } = this.state;

        let params = {
            page:1,
            records:9999
        }

        if( circleCenterValue !== undefined && circleCenterValue !== null && circleCenterValue !== ""){
            params["realm_id"] = circleCenterValue
        }

        WidgetAjax.ajax({url:basePath + 'role/search', params:params, callback:this.onLoadGroup});
    }

    onLoadGroup( result )
    {
        if( result.status===0 )
        {
            
                let groupData = [];

                    for(let item of result.results)
                    {
                        item["value"] = item.id;
                        item["label"] = item.name;
        
                        groupData.push(item);
                    }
                    this.setState({groupData:groupData});
                
            
        }
        else if( result.status===10 )
        {
            Cache.logout(this.props);
        }
    }

    loadUserGroup()
    {
        const { basePath, user } = this.state;
        let params = {
            UID : user.UID,
            page:1,
            records:9999
        };

        WidgetAjax.ajax({url:basePath + 'user/role', params:params, callback:this.onLoadUserGroup});
    }

    onLoadUserGroup(result, params )
    {
        if( result.status===0 )
        {
           
                let userGroups = [], groups=[];

                if( result.results!==undefined )
                {
                    for( let group of result.results )
                    {
                        userGroups.push(group.id);
                        groups.push(group.id)
                    }
                } 
                let str = groups.toString()
                this.state["groups"] = str
                this.setState({userGroups:userGroups});
            
        }
        else if( result.status===10 )
        {
            Cache.logout(this.props);
        }
    }

    // 部门数据
    loadUserDepartment()
    {
        const { basePath, user, circleCenterValue} = this.state;

        let params = {
            UID : user.UID,
            page:1,
            records:-1
        };

        WidgetAjax.ajax({url:basePath + 'user/department', params:params, callback:this.onLoadUserDepartment});
    }

    onLoadUserDepartment(result, params )
    {

        if( result.status===0 )
        {
            let userDepartments= [], userDepartmentNames= "", isFirst = true;

            if( result.results!==undefined )
            {
                for( let item of result.results )
                {
                    userDepartments.push(item);

                    if( isFirst )
                    {
                        isFirst=false;

                        userDepartmentNames = item.name;
                    }
                    else 
                    {
                        userDepartmentNames += ", " + item.name;
                    }
                }
            } 
            this.setState({userDepartments:userDepartments, confirmDepartments:userDepartments, 
                userDepartmentNames:userDepartmentNames, confirmDepartmentNames : userDepartmentNames, departmentNames:userDepartmentNames
            });
        }
        else if( result.status===10 )
        {
            Cache.logout(this.props);
        }
    }

    loadUserGroupName()
    {
        const { basePath, user, circleCenterValue} = this.state;

        let params = {
            UID : user.UID,
            page:1,
            records:9999
        };
        if( circleCenterValue !== undefined && circleCenterValue !== null && circleCenterValue !== ""){
            params["realm_id"] = circleCenterValue
        }

        WidgetAjax.ajax({url:basePath + 'user/group', params:params, callback:this.onUserGroupName});
    }
    onUserGroupName(result)
    {
        if( result.status===0 )
        {
            let groupingNamesDate= [], groupingNames= "", isFirst = true;

            if( result.results!==undefined )
            {
                for( let item of result.results )
                {
                    groupingNamesDate.push(item);

                    if( isFirst )
                    {
                        isFirst=false;

                        groupingNames = item.name;
                    }
                    else 
                    {
                        groupingNames += ", " + item.name;
                    }
                }
            } 
            this.setState({groupingNames:groupingNames,userGroupSearchData:groupingNamesDate,groupSearchData:groupingNamesDate});
        }
        else if( result.status===10 )
        {
            Cache.logout(this.props);
        }
    }
    /**
     * input输入框变化函数
     * @param {*} value 
     * @param {*} type 
     */
    inputOnchange( value, type)
    {
        switch( type )
        {
            case "username":
            {
                this.state["username"] = value;
                break;
            }
            case "realname":
            {
                this.state["realname"] = value;
                break;
            }
            case "cell":
            {
                this.state["cell"] = value;
                break;
            }
            case "email":
            {
                this.state["email"] = value;
                break;
            }
            case "remark":
            {
                this.state["remark"] = value;
                break;
            }
            default:
                break;
        }
    }

    /**
     * 角色选择回调函数
     */
    groupOnSelect( value,type )
    {
        switch( type )
        {
            case 'type':
            {
                this.state["groups"] = value;
                break;
            }
            default:
                break;
        }
    }

    /**
     * 抽屉的确定函数
     */
    drawerConfirm()
    {
        let { departments } = this.state, isFirst = true;

        let confirmDepartments = [], confirmDepartmentNames = "";

        confirmDepartments.push(...departments);

        for( let item of departments )
        {
            if( isFirst )
            {
                confirmDepartmentNames = item.name;
                isFirst = false;
            }
            else
            {
                confirmDepartmentNames += ", " + item.name;
            }
        }


        this.setState({confirmDepartments:confirmDepartments, confirmDepartmentNames:confirmDepartmentNames, departmentNames:confirmDepartmentNames });

        this.drawerRef.close();
    }

    /**
     * 部门选择弹出
     */
    departmentSelect()
    {
        let { confirmDepartments, confirmDepartmentNames } = this.state, departments = [], departmentNames=undefined;
        
        if( confirmDepartments )
        {
            departments.push(...confirmDepartments);
        }

        departmentNames = confirmDepartmentNames;
        
        this.setState({departments:departments, departmentNames: departmentNames});

        this.drawerRef.open();
    }

    // 用户分组数据
    loadUserGrouping(page)
    {
        const { basePath, user, circleCenterValue, groupKeyWord, options} = this.state;

        if( page===undefined )
        {
            page = 1;
        }

        let params = {
            page : page,
            records : options.records
        };

        if( groupKeyWord!==undefined && groupKeyWord!==null && groupKeyWord!=="")
        {
            params["name"] = groupKeyWord;
        }
        if( circleCenterValue !== undefined && circleCenterValue !== null && circleCenterValue !== ""){
            params["realm_id"] = circleCenterValue
        }

        WidgetAjax.ajax({url:basePath + 'group/search', params:params, callback:this.onLoadUserGrouping});
    }
    onLoadUserGrouping(result,params)
    {
        if( result.status===0 )
        {
            let { options } = this.state;

            options["page"] = params.page;

           this.setState({groupSearch:result.results, total:result.total, options:options})
        }
        else if( result.status===10 )
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 用户分组弹出
     */
    groupingSelect()
    {
        this.groupSearchRef.open();
    }

    /**
     * 搜索关键字变化回调函数 
     * @param {*} value 
     * @param {*} event 
     */
     groupKeyWordOnChange(value, event)
     {
         this.setState({groupKeyWord:value});
     }
    /**
     * 键盘事件捕获
     * @param {*} e 
     */
    groupKeyWordKeyUp( e )
    {
        /** 判断是否是回车事件 */
        if( e.keyCode===13 )
        {
            this.loadUserGrouping(1);
        }
    }

    /**
     * 用户分组
     * @param {*} type 
     * @param {*} data 
     * @param {*} value 
     * @param {*} event 
     */
    onGroupEvent(type, data, value, event)
    {
        if( data!==undefined )
        {
            data = JSON.parse(data);
        }
        
        let arr =[]
        
        switch( type )
        {
            case "departmentOnSelect":
            {
                let { groupSearchData,groupSearch,userGroupSearchData } = this.state;
                

                for(let item of groupSearch){
                    if(item.name === value){
                        let index = !groupSearchData?-1:groupSearchData.findIndex(group=>group.id==item.id);
                        if(index==-1){
                            arr.push(item)
                        }
                    }
                }
               
                this.setState({groupSearchData:!groupSearchData?arr:[...groupSearchData,...arr]});
                break;
            }
            default:
                break;
        }
    }
    

    /**
     * 用户分组抽屉的确定函数
     */
     groupConfirm()
     {
         let {groupSearchData} = this.state, isFirst = true;
        //  let { departments } = this.state, isFirst = true;
 
         let confirmDepartments = [], confirmDepartmentNames = "";
 
        //  confirmDepartments.push(...departments);
        
        if(groupSearchData!==undefined && groupSearchData !== null && groupSearchData !== ""){

            for( let item of groupSearchData )
            {
                if( isFirst )
                {
                    confirmDepartmentNames = item.name;
                    isFirst = false;
                }
                else
                {
                    confirmDepartmentNames += ", " + item.name;
                }
            }
            this.setState({groupingNames:confirmDepartmentNames})
        }
        
 
 
        //  this.setState({confirmDepartments:confirmDepartments, confirmDepartmentNames:confirmDepartmentNames, departmentNames:confirmDepartmentNames });
 
         this.groupSearchRef.close();
     }



    /**
     * 搜索关键字变化回调函数 
     * @param {*} value 
     * @param {*} event 
     */
    keyWordOnChange(value, event)
    {
        this.setState({keyWord:value});
    }

    /**
     * 键盘事件捕获
     * @param {*} e 
     */
    keyWordKeyUp( e )
    {
        /** 判断是否是回车事件 */
        if( e.keyCode===13 )
        {
            this.departmentSearch();
        }
    }

    /**
     * 部门搜索函数
     */
    departmentSearch( page )
    {
        const { basePath, keyWord, tableOptions,circleCenterValue } = this.state;

        if( page===undefined )
        {
            page = 1;
        }

        let params = {
            page:page,
            records : tableOptions.records
        };

        if( keyWord!==undefined && keyWord!==null && keyWord!=="")
        {
            params["name"] = keyWord;
        }

        if(circleCenterValue !== undefined && circleCenterValue!==null && circleCenterValue!==""){
            params["realm_id"] = circleCenterValue;
        }

        WidgetAjax.ajax({url:basePath + 'department/search', params:params, callback:this.onDepartmentSearch});
    }

    /**
     * 部门搜索回调函数
     * @param {*} result 
     * @param {*} params 
     */
    onDepartmentSearch( result, params )
    {
        if( result.status===0 )
        {
            let { tableOptions } = this.state;

            tableOptions["page"] = params.page;

            this.setState({data:result.results, departmentTotal:result.total, tableOptions:tableOptions});
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 表格翻页
     * @param {*} page 
     */
    pageTurning( page )
    {
        this.departmentSearch(page);
    }

    /**
     * 表格翻页
     * @param {*} page 
     */
    groupPageTurning( page )
    {
        this.loadUserGrouping(page);
    }

    /**
     * 部门
     * @param {*} type 
     * @param {*} data 
     * @param {*} value 
     * @param {*} event 
     */
    onEvent(type, data, value, event)
    {
        if( data!==undefined )
        {
            data = JSON.parse(data);
        }

        switch( type )
        {
            case "departmentOnSelect":
            {
                let { departments } = this.state, isExist = false;

                for( let item of departments)
                {
                    if( item.id===data.id )
                    {
                        isExist = true;
                        break;
                    }
                }

                if( isExist===false )
                {
                    departments.push(data);
                }
                
                this.setState({departments:departments});
                break;
            }
            default:
                break;
        }
    }

    removeDepartment( item )
    {
        let { departments } = this.state;

        for( let i=0; i<departments.length; i++ )
        {
            if( item.id===departments[i].id)
            {
                departments.splice(i, 1);
            }
        }

        this.setState({departments:departments});
    }
    removeDate(item){
        let { groupSearchData } = this.state;

        for( let i=0; i<groupSearchData.length; i++ )
        {
            if( item.id===groupSearchData[i].id)
            {
                groupSearchData.splice(i, 1);
            }
        }

        this.setState({groupSearchData:groupSearchData});
    }

    // 创建和编辑
    submitUser()
    {
        const { basePath, username, realname, cell, email, remark, isCreate, user, groups, confirmDepartments, messageOptions,startDate,startDate1,circleCenterValue } = this.state;
        let  startValue= moment(startDate1).format('YYYY-MM-DD');
        if( username===undefined || username===null || username==="" )
        {

            messageOptions["message"] = "用户名不能为空！";

            messageOptions["isMessage"] = true;

            this.state["messageOptions"] = messageOptions;

            this.messageRef.open();

            return ;
        }

        if( realname===undefined || realname===null || realname==="" )
        { 
            messageOptions["message"] = "用户姓名不能为空";

            messageOptions["isMessage"] = true;

            this.state["messageOptions"] = messageOptions;

            this.messageRef.open();

            return ;
        }

        if( groups===undefined || groups===null || groups==="" || groups.length===0 )
        {
            messageOptions["message"] = "请选择用户角色！";

            messageOptions["isMessage"] = true;

            this.state["messageOptions"] = messageOptions;

            this.messageRef.open();

            return ;
        }
        if(circleCenterValue !== undefined && circleCenterValue !== null && circleCenterValue.length === 0){
            messageOptions["message"] = "请选择用户领域！";

            messageOptions["isMessage"] = true;

            this.state["messageOptions"] = messageOptions;

            this.messageRef.open();

            return ;
        }
        
        
       
        // 判断新增还是编辑
        let param={
            realname:realname,
            username : username,
            remark : remark,
            realm_id : circleCenterValue
        }
        
        let reg =/^0?1[3|4|5|6|7|8][0-9]\d{8}$/;
        if(cell !== undefined){
            if(reg.test(cell))
            {
                param["cell"] = cell
            }
            else
            {
                messageOptions["message"] = "请选择输入正确的手机号！";
    
                messageOptions["isMessage"] = true;
    
                this.state["messageOptions"] = messageOptions;
    
                this.messageRef.open();
    
                return ;
            }
        }
        
        
        var magey = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
        if(email !== undefined){
            if(magey.test(email))
            {
                param["email"] = email
            }
            else
            {
                messageOptions["message"] = "请选择输入正确的邮箱！";
    
                messageOptions["isMessage"] = true;
    
                this.state["messageOptions"] = messageOptions;
    
                this.messageRef.open();
    
                return ;
            }
        }

        if( user!==undefined && user.UID!==undefined  )
        {
            let params = {
                UID : user.UID,
                ...param
            }
            
            WidgetAjax.ajax({url:basePath + 'user/update', params:params, callback:this.onEdituser});
        }
        else
        {
            let params = {
                type:0,
                ...param
            }
            WidgetAjax.ajax({url:basePath + 'user/create', params:params, callback:this.onsubmitUser});
        }

        this.state["isCreate"]=false;

    }

    // 新增的回调
    /**
     * 返回参数与传递参数
     * @param {*} result 
     * @param {*} params 
     */
    onsubmitUser( result )
    {
        const { basePath, realname, cell, email, remark, messageOptions,startDate1,circleCenterValue} = this.state;

        if( result.status===0 )
        {
            let params = {
                UID : result.UID,
                realname:realname,
                realm_id:circleCenterValue
            }

            if(cell!==undefined && cell !== null && cell !=="")
            {
                params["cell"] = cell
            }

            if(email!==undefined && email !== null && email !=="")
            {
                params["email"] = email
            }

            if(remark!==undefined && remark !== null && remark !=="")
            {
                params["remark"] = remark
            }

            this.state["user"]["UID"] = result.UID;
            WidgetAjax.ajax({url:basePath + 'user/update', params:params, callback:this.onEdituser})

        }
        else
        {   
            messageOptions["message"] = "用户创建失败！ " + result.message;

            messageOptions["isMessage"] = true;

            this.state["messageOptions"] = messageOptions;

            this.messageRef.open();
        }
    }

    onEdituser( result )
    {   
        let {messageOptions,startDate1,groupSearchData,groups,confirmDepartments} = this.state;
        let  startValue= moment(startDate1).format('YYYY-MM-DD');
        if( result.status===0 )
        {
            if(groupSearchData !== undefined && groupSearchData !== null && groupSearchData !== "")
            {
                this.setUserGroup();
            }

            if(groups !== undefined && groups !== null && groups !== "")
            {
                this.setUserRole();
            }

            if(confirmDepartments !== undefined && confirmDepartments !== null && confirmDepartments !== "")
            {
                this.setUserDepartment();
            }
            
            if(startDate1 !== undefined && startDate1 !== null && startDate1 !== "")
            {
                this.startValueDate()
            }
        }
        else
        {
            messageOptions["message"] = "用户信息更新失败！ " + result.message;

            messageOptions["isMessage"] = true;

            this.state["messageOptions"] = messageOptions;

            this.messageRef.open();
        }
    }

    setUserGroup()
    {
        const { basePath, user, groupSearchData } = this.state;
        let arr = [];
        for(let item of groupSearchData){
            arr.push(item.id)
        }
        let params = {
            UID : user.UID,
            group_ids:arr
        }

        WidgetAjax.ajax({url:basePath + 'user/set_group', params:params, callback:this.onSetUserGroup});
    }

    onSetUserGroup( result )
    {
        let {messageOptions} = this.state;

        if( result.status===0 )
        {
            // this.setUserRole()
        }
        else
        {
            messageOptions["message"] = "用户信息更新失败！ " + result.message;

            messageOptions["isMessage"] = true;

            this.state["messageOptions"] = messageOptions;

            this.messageRef.open();
        }
    }

    startValueDate(){
        const { basePath, user, startDate1 } = this.state;

        let startValue= moment(startDate1).format('YYYY-MM-DD');

        startValue = startValue + " 23:59:59"

        let params = {
            UID : user.UID,
            date:startValue
        }

        WidgetAjax.ajax({url:basePath + 'user/update_expiration_date', params:params, callback:this.onstartValueDate});
    }
    onstartValueDate(result)
    {
        let {messageOptions} = this.state;

        if( result.status===0 )
        {
            // this.setUserDepartment()
        }
        else
        {
            messageOptions["message"] = "用户信息更新失败！ " + result.message;

            messageOptions["isMessage"] = true;

            this.state["messageOptions"] = messageOptions;

            this.messageRef.open();
        }
    }

    setUserRole()
    {
        const { basePath, user, groups } = this.state;
        let arr = []
        arr.push(groups)
        let params = {
            UID : user.UID,
            roleIds:arr,
            role_ids:arr
        }

        WidgetAjax.ajax({url:basePath + 'user/set_role', params:params, callback:this.onSetUserGroup});
    }

    onSetUserRole( result )
    {
        let {messageOptions} = this.state;

        if( result.status===0 )
        {
            // this.setUserDepartment()
        }
        else
        {
            messageOptions["message"] = "用户信息更新失败！ " + result.message;

            messageOptions["isMessage"] = true;

            this.state["messageOptions"] = messageOptions;

            this.messageRef.open();
        }
    }

    setUserDepartment()
    {
        const { basePath, user, confirmDepartments } = this.state;
        console.log(user);

        let departmentIds = [];

        for( let item of confirmDepartments )
        {
            departmentIds.push(item.id);
        }
        let params = {
            UID : user.UID,
            departmentIds : departmentIds,
            department_ids: departmentIds
        }

        WidgetAjax.ajax({url:basePath + 'user/set_department', params:params, callback:this.onSetUserDepartment});
    }

    onSetUserDepartment(result)
    {
        let { messageOptions } = this.state;
        if( result.status===0 )
        {
            messageOptions["message"] = "创建用户成功!"

            messageOptions["isMessage"] = true;

            this.messageRef.open();

            setTimeout(()=>{
                this.backUser();
            },1500)
        }
        else if( result.status===10 )
        {
            Cache.logout(this.props);
        }
        else
        {
            messageOptions["message"] = "用户信息更新失败！ " + result.message;

            messageOptions["isMessage"] = true;

            this.state["messageOptions"] = messageOptions;

        }
    }

    onDateSelect( value )
    {
        if( value!==undefined )
        {
            this.setState({startDate:value.start });
        }
    }

    onEndDateSelect( value )
    {
            let {startDate1} = this.state;
            // this.state["startDate1"] = value.end
            setTimeout(() => {
                this.setState({ startDate1:value.end });
            },100)
    }

    /**
     * 用户领域回调函数
     * @param {*} values 
     */
    onSelectCircleCenter( values )
    {
        if( values!==undefined && values.length===1 )
        {
            this.state["circleCenterValue"] = values[0];

            this.setState({circleCenterValue:values[0],groups:undefined})
            // this.loadUserGroupName()
            setTimeout(() => {
                this.loadUserGrouping()
                this.departmentSearch()
                this.loadGroup()
            },100)
            
        }
    }

    render()
    {

        let { title, layout, groupOptions, groupData, drawerOptions, tableOptions, columns, data, total, keyWord, filterTypeOptions,filterBankData,circleCenterValue,
            username, realname, cell, email, remark, groups, departments, departmentNames, messageOptions,startDate,dateOptions,endDateOptions,startDate1,
            groupSearch, groupSearchData,columns1,groupKeyWord,groupingNames,roleOptions,flag,user,options, departmentTotal
        } = this.state;
        return (
            <div className="page">
                {/* <div className="page-weidu">
                    <div className="page-title">
                        <div className='go_back' onClick={this.backUser}><img src={require('./img/icon/goback.svg')} /></div>
                    </div>
                </div> */}
                
                        {/* <div className="page-title-img"><img src={require("./img/ml-ztzt.png")} alt=""></img></div>
                        <span className="page-title-font">用户管理</span>/ <span className="page-title-path-font">{title}</span> */}

                <div className="page-content page-overflow" style={{height:"100%"}}>
                    <div className="user-create" style={{position:'relative',height:"table"}}>
                        <div className="title">
                        <div className='go_back' onClick={this.backUser}><img src={require('./img/icon/back.svg')} /></div>
                            <p className='go_back_title'>用户管理<span style={{color:"#646464"}}>{"/ 新增角色"}</span></p>
                        </div>
                        <div className="content" style={{display:'table',paddingBottom:"50px"}}>
                            <Form  {...layout} name="basic">         
                                <Form.Item label="用户名" name="username">
                                    <Input defaultValue={username} placeholder={"请输入用户名（必填项）"} onChange={(value) => {this.inputOnchange(value, "username")}} ></Input>
                                </Form.Item>
                                <Form.Item label="姓名" name="realname">
                                    <Input defaultValue={realname} placeholder={"请输入用户姓名（必填项）"} onChange={(value) => {this.inputOnchange(value, "realname")}}></Input>
                                </Form.Item>
                                <Form.Item label="手机号" name="cell">
                                    <Input defaultValue={cell} placeholder={"请输入手机号"} onChange={(value) => {this.inputOnchange(value, "cell")}}></Input>
                                </Form.Item>
                                

                                <Form.Item label="电子邮箱" name="email">
                                    <Input defaultValue={email} placeholder={"请输入电子邮箱"} onChange={(value) => {this.inputOnchange(value, "email")}}></Input>
                                </Form.Item>

                                <Form.Item label="用户领域" name="section">
                                    <WidgetTreePicker onSelect={this.onSelectCircleCenter} onChange={this.onSelectCircleCenter} 
                                        options={filterTypeOptions} data={filterBankData} defaultValue={circleCenterValue} flag={flag} />
                                </Form.Item>

                                <Form.Item label="角色" name="group">
                                    <WidgetSelect options={roleOptions} data={groupData} defaultValue={groups} 
                                        onSelect={(value)=>this.groupOnSelect(value,"type")} Select={true}></WidgetSelect> 
                                </Form.Item>

                                <Form.Item label="分组" name="grouping">
                                    <div onClick={this.groupingSelect}>
                                        <Input defaultValues={groupingNames} value={groupingNames} placeholder={"请选择"} readOnly="readonlys"></Input>
                                    </div>
                                </Form.Item>

                                <Form.Item label="部门" name="department">
                                    <div onClick={this.departmentSelect}>
                                        <Input defaultValues={departmentNames} value={departmentNames} placeholder={"请选择"} readOnly="readonly"></Input>
                                    </div>
                                </Form.Item>

                                {/* <Form.Item label="生效时间">
                                    <WidgetDatePicker onSelect={(value)=>{this.onDateSelect(value)}} 
                                        defaultValue={{dateStart:startDate,dateEnd:endDate, dateType:"date"}}
                                        options={dateOptions}/>
                                </Form.Item> */}

                                <Form.Item label="失效时间">
                                    <WidgetDatePicker onSelect={(value)=>{this.onEndDateSelect(value)}} 
                                        defaultValue={{dateStart:startDate1, dateEnd:startDate1, dateType:"date"}}
                                        options={endDateOptions}
                                        footer={true}
                                        />
                                </Form.Item>
                                
                                <Form.Item label="备注" name="remark">
                                    <Input componentClass="textarea" defaultValue={remark} placeholder={"请输入备注"}  onChange={(value) => {this.inputOnchange(value, "remark")}}></Input>
                                </Form.Item>

                            </Form>

                        </div>

                        <div className="content-footer">
                            <div className="footer-button">
                                <div className="button footer-cancel" onClick={this.cancel}>
                                    <span className="addUser">取消</span>
                                </div>
                                <div className="button footer-submit" onClick={this.submitUser}>
                                    <span className="addUser">保存</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <WidgetDrawer options={ drawerOptions } onRef={this.drawerRef} >
                    <div className="white department-drawer" style={{height:'calc(100vh - 70px)', overflow: 'auto'}}>
                        <div className="title"><span>添加部门</span></div>

                        <div className="department-select"> 
                            <div className="title">
                                <span>已选部门</span>
                            </div>
                            <div className="department-drawer-label" style={{paddingLeft:"16px"}}>
                            {
                                departments.map((item, index)=>{
                                    return (
                                        <div key={index} className="department-label">
                                            <label>{item.name}</label>
                                            <label className="close" onClick={()=>{this.removeDepartment(item)}}> × </label>
                                        </div>
                                    )
                                }) 
                            }
                            </div>
                        </div>

                        <div className="department-content" style={{minHeight:'60vh', padding: 20}}>
                            <div className="content-title">
                                <div className="search">
                                    <InputGroup className="InputGroup"  >
                                        <Input name="Serchkey" defaultValue={keyWord} placeholder="请输入搜索内容" onChange={this.keyWordOnChange } onKeyUp={this.keyWordKeyUp} />
                                        <InputGroup.Addon><Icon icon="search" onClick={ ()=> {this.departmentSearch(1)}} /></InputGroup.Addon>
                                    </InputGroup>
                                </div>
                            </div>
                            <div className="report">
                                <WidgetTable options={tableOptions} columns={columns} data={data} total={departmentTotal} notify={this.onEvent} pageTurning={this.pageTurning}></WidgetTable>
                            </div>
                        </div>                    
                    </div>
                </WidgetDrawer>

                <WidgetDrawer options={ groupOptions } onRef={this.groupSearchRef} >
                    <div className="white department-drawer" style={{height:'calc(100vh - 70px)', overflow: 'auto'}}>
                        <div className="title"><span>添加分组</span></div>

                        <div className="department-select"> 
                            <div className="title">
                                <span>已选分组</span>
                            </div>
                            <div className="department-drawer-label" style={{paddingLeft:"16px"}}>
                            <>{groupSearchData===undefined?"":
                                groupSearchData.map((item, index)=>{
                                    return (
                                        <div key={index} className="department-label">
                                            <label>{item.name}</label>
                                            <label className="close" onClick={()=>{this.removeDate(item)}}> × </label>
                                        </div>
                                    )
                                }) 
                            }</>
                            </div>
                        </div>

                        <div className="department-content" style={{minHeight:'60vh', padding: 20}}>
                            <div className="content-title">
                                <div className="search">
                                    <InputGroup className="InputGroup"  >
                                        <Input name="groupSearch" defaultValue={groupKeyWord} placeholder="请输入搜索内容" onChange={ this.groupKeyWordOnChange } onKeyUp={ this.groupKeyWordKeyUp} />
                                        <InputGroup.Addon><Icon icon="search" onClick={()=> {this.loadUserGrouping(1)}} /></InputGroup.Addon>
                                    </InputGroup>
                                </div>
                            </div>
                            <div className="report">
                                <WidgetTable options={options} columns={columns1} data={groupSearch} total={total} notify={this.onGroupEvent} pageTurning={this.groupPageTurning}></WidgetTable>
                            </div>
                        </div>                    
                    </div>
                </WidgetDrawer>

                <WidgetMessage options={messageOptions} onRef={this.messageRef} />
            </div>
        )
        
    }
}

export default UserCreate